import { Breadcrumbs } from "@itandi/itandi-bb-ui/Breadcrumbs";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import Link from "next/link";
import { useState } from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { TodoTemplateList } from "~/components/common/todo_templates/TodoTemplateList";
import { TodoTemplateModal } from "~/components/common/todo_templates/TodoTemplateModal";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import { useSubtypes } from "~/hooks/useSubtypes";
import { PATH } from "~/pages/settings/subtypes";
import SettingStyles from "../../../SettingStyle.module.scss";

export function Page() {
	const id = useIdQueryHandler("subtypeId");
	const { data: subtype } = useSubtypes().useShow(id);
	const [isOpen, setIsOpen] = useState(false);

	if (subtype === null) {
		return null;
	}

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<div className={SettingStyles.BreadcrumbsBlock}>
					<Breadcrumbs
						items={[
							{ as: Link, href: PATH, label: "案件タイプ設定" },
							{ label: "TODOテンプレート設定" }
						]}
					/>
				</div>
				<Panel>
					<PanelHeader
						rightArea={
							<Button
								onClick={() => {
									setIsOpen(true);
								}}
								variant="primary"
							>
								追加
							</Button>
						}
						title={`${subtype.name} TODOテンプレート設定`}
					/>
					<PanelBody>
						<TodoTemplateList dealType="other" subtypeId={subtype.id} />
					</PanelBody>
				</Panel>
				{isOpen ? (
					<TodoTemplateModal
						dealType="other"
						handleClose={() => {
							setIsOpen(false);
						}}
						subtypeId={subtype.id}
					/>
				) : null}
			</ClientSettingLayout>
		</DefaultV2>
	);
}
